import { render, staticRenderFns } from "./education.page.vue?vue&type=template&id=3afeb667&scoped=true&"
import script from "./education.page.vue?vue&type=script&lang=js&"
export * from "./education.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afeb667",
  null
  
)

export default component.exports